import styled, { keyframes } from 'styled-components'

type TSlideProps = {
  hasReverse?: boolean
}

const scroll = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-474px);
  }
`

export const StyledSlider = {
  AnimationsContainer: styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    max-width: 360px;
    max-height: 430px;
    padding: 0 10px;
    margin: 0 auto;
  `,
  SliderContainer: styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    user-select: none;
  `,
  SlideList: styled.ul<TSlideProps>`
    flex-shrink: 0;
    min-height: 430px;
    animation: ${scroll} 20s linear infinite;
    animation-direction: ${({ hasReverse }) =>
      hasReverse ? 'reverse' : 'normal'};
  `,
  Image: styled.img`
    max-width: 166px;
    image-rendering: -webkit-optimize-contrast;
  `,
  Shadow: styled.div`
    position: absolute;
    width: 100%;
    min-height: 66px;
    bottom: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(19, 27, 65, 0) 0%, #13182a 100%);
  `,
}
